<template>
  <el-dropdown size="small" class="d2-mr">
    <span class="btn-text" :style="avatarParentBoxSty">
      <img :style="avatarStyle" class="avatar" :src="info.avatar" alt="" />
      <span>{{ info.name ? `你好 ${info.name}` : '未登录' }}</span>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off" class="d2-mr-5" />
        注销
      </el-dropdown-item>
      <el-dropdown-item @click.native="openLogin" v-if="$store.state.d2admin.user.info.systemUserId == 1">
        <d2-icon name="power-off" class="d2-mr-5" />
        强制登录
      </el-dropdown-item>
      <!-- <el-dropdown-item @click.native="updatePassword">
        <d2-icon name="lock" class="d2-mr-5"/>
        修改密码
      </el-dropdown-item> -->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState('d2admin/user', ['info']),
    avatarStyle() {
      return !!this.info.avatar
        ? {
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            paddingRight: '5px'
          }
        : ''
    },
    avatarParentBoxSty() {
      return !!this.info.avatar ? { display: 'flex', alignItems: 'center' } : ''
    }
  },
  methods: {
    ...mapActions('d2admin/account', ['logout', 'updateSelfPassword']),
    /**
     * @description 登出
     */
    logOff() {
      this.logout({
        vm: this,
        confirm: true
      })
    },
    updatePassword() {
      this.updateSelfPassword({ vm: this })
    },
    // 打开强制登录弹框
    openLogin() {
      this.$emit('compelLogin')
    }
  }
}
</script>
